/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { commentControllerActivate } from '../fn/comments/comment-controller-activate';
import { CommentControllerActivate$Params } from '../fn/comments/comment-controller-activate';
import { commentControllerCleanup } from '../fn/comments/comment-controller-cleanup';
import { CommentControllerCleanup$Params } from '../fn/comments/comment-controller-cleanup';
import { commentControllerCreate } from '../fn/comments/comment-controller-create';
import { CommentControllerCreate$Params } from '../fn/comments/comment-controller-create';
import { commentControllerCreateInactive } from '../fn/comments/comment-controller-create-inactive';
import { CommentControllerCreateInactive$Params } from '../fn/comments/comment-controller-create-inactive';
import { commentControllerGetAll } from '../fn/comments/comment-controller-get-all';
import { CommentControllerGetAll$Params } from '../fn/comments/comment-controller-get-all';
import { CommentItem } from '../models/comment-item';
import { CommentListForMonitoring } from '../models/comment-list-for-monitoring';
import { EmptyResponse } from '../models/empty-response';

@Injectable({ providedIn: 'root' })
export class CommentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commentControllerCreateInactive()` */
  static readonly CommentControllerCreateInactivePath = '/monitoring/{monitoringId}/comments/create-inactive';

  /**
   * Crea un commento placeholder inattivo per il file manager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerCreateInactive()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerCreateInactive$Response(params: CommentControllerCreateInactive$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>> {
    const obs = commentControllerCreateInactive(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un commento placeholder inattivo per il file manager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerCreateInactive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerCreateInactive(params: CommentControllerCreateInactive$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommentItem;
}> {
    const resp = this.commentControllerCreateInactive$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>): BaseResponse & {
'data'?: CommentItem;
} => r.body)
    );
  }

  /** Path part for operation `commentControllerActivate()` */
  static readonly CommentControllerActivatePath = '/monitoring/{monitoringId}/comments/{id}/activate';

  /**
   * Attiva un commento placeholder con i dati definitivi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerActivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerActivate$Response(params: CommentControllerActivate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>> {
    const obs = commentControllerActivate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Attiva un commento placeholder con i dati definitivi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerActivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerActivate(params: CommentControllerActivate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommentItem;
}> {
    const resp = this.commentControllerActivate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>): BaseResponse & {
'data'?: CommentItem;
} => r.body)
    );
  }

  /** Path part for operation `commentControllerCleanup()` */
  static readonly CommentControllerCleanupPath = '/monitoring/{monitoringId}/comments/{id}/cleanup';

  /**
   * Pulisce i file e cancella un commento inattivo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerCleanup()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerCleanup$Response(params: CommentControllerCleanup$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = commentControllerCleanup(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Pulisce i file e cancella un commento inattivo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerCleanup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerCleanup(params: CommentControllerCleanup$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.commentControllerCleanup$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `commentControllerGetAll()` */
  static readonly CommentControllerGetAllPath = '/monitoring/{monitoringId}/comments';

  /**
   * Ritorna i commenti di un monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerGetAll$Response(params: CommentControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentListForMonitoring;
}>> {
    const obs = commentControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna i commenti di un monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerGetAll(params: CommentControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommentListForMonitoring;
}> {
    const resp = this.commentControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommentListForMonitoring;
}>): BaseResponse & {
'data'?: CommentListForMonitoring;
} => r.body)
    );
  }

  /** Path part for operation `commentControllerCreate()` */
  static readonly CommentControllerCreatePath = '/monitoring/{monitoringId}/comments';

  /**
   * Inserisce un commento su un monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate$Response(params: CommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>> {
    const obs = commentControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Inserisce un commento su un monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate(params: CommentControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommentItem;
}> {
    const resp = this.commentControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>): BaseResponse & {
'data'?: CommentItem;
} => r.body)
    );
  }

}
